import { useTranslation } from "@redotech/redo-i18n";
import EditPencilIcon from "@redotech/redo-icons/edit-01.svg";
import FolderOpenIcon from "@redotech/redo-icons/folder-open.svg";
import FolderIcon from "@redotech/redo-icons/folder.svg";
import { memo, ReactNode } from "react";
import { RedoSecondaryNavItem } from "./redo-secondary-nav-item";

export const RedoNavFolder = memo(function RedoNavFolder({
  children,
  folderEditRequested,
  folderId,
  folderName,
  anyChildSelected,
  "data-dd-action-name": actionName,
}: {
  "data-dd-action-name"?: string;
  folderId: string;
  folderName: string;
  anyChildSelected: boolean;
  children: ReactNode | ReactNode[];
  folderEditRequested: () => void;
}) {
  const { t } = useTranslation();
  return (
    <RedoSecondaryNavItem
      action={{ type: "button" }}
      anyChildSelected={anyChildSelected}
      data-arbiter="RedoNavFolder"
      data-dd-action-name={actionName}
      FilledIcon={FolderOpenIcon}
      friendlyName={folderName}
      id={folderId}
      isFolder
      UnfilledIcon={FolderIcon}
    >
      {[
        children,
        <RedoSecondaryNavItem
          action={{ type: "button", onClick: folderEditRequested }}
          FilledIcon={EditPencilIcon}
          friendlyName={t("Edit folder")}
          id="edit-folder"
          key="edit-folder"
          UnfilledIcon={EditPencilIcon}
        />,
      ]}
    </RedoSecondaryNavItem>
  );
});
